import { z } from "zod";
export const transportVehicleTypes = ["car", "van"];
export const vehicleTransportSchema = z.object({
    vehicleMake: z.string().min(1, "Vehicle make is required"),
    vehicleModel: z.string().min(1, "Vehicle model is required"),
    vehicleYear: z.number().int().min(1900).max(new Date().getFullYear() + 1),
    vehicleType: z.enum(transportVehicleTypes, { message: "Select type" }),
    isDriveable: z.boolean().optional(),
    enclosedTransport: z.boolean().optional(),
    vehicleCount: z.number().int().min(1).max(10).optional(),
    needsConditionReport: z.boolean().optional(),
    photos: z.array(z.string()).max(3, "Max 3 photos").optional(),
    notes: z.string().max(500).optional(),
});
//# sourceMappingURL=schema.js.map